// import { Select } from "../../ui/Select";
// import { Input } from "../../ui/Input";
// import { RadioGroup } from "../../ui/RadioGroup";
// import { SelectCurrency } from "../../selectors/currency/selectCurrency";

// export const TransactionForm = ({
//   formData,
//   existingTransaction,
//   handleChange,
//   isReadOnly,
//   handleUpdate,
//   handleTransactionChange,
//   isSelectorReadOnly,
//   isReport,
// }) => {
//   return (
//     <form onSubmit={handleUpdate}>

//       {!isReport && <Select
//         label="Quick Fill Existing Transaction:"
//         name="transactionId"
//         value={formData.transactionId}
//         disabled={isReadOnly || isSelectorReadOnly}
//         options={
//           existingTransaction && existingTransaction.length > 0
//             ? existingTransaction
//               .filter((value) => value != null)
//               .map((value) => parseInt(value))
//               .sort((a, b) => b - a)
//               // .sort()
//               .map((value) => ({
//                 value,
//                 display_value: value,
//               }))
//             : [{ value: "", display_value: "No Transactions available" }]
//         }
//         onChange={handleTransactionChange}
        
//       />}

//       <Input
//         label="Transaction ID"
//         type="text"
//         value={formData.transactionId}
//         placeholder={"Auto Generated"}
//         disabled={true}
//         isReport={isReport}
//       />
//       <Input
//         label="Transaction Status"
//         type="text"
//         value={formData.status}
//         disabled={true}
//         isReport={isReport}
//       />

//       <RadioGroup
//         label="Transaction Type"
//         name="transactionType"
//         required={true}
//         value={formData.transactionType}
//         onChange={handleChange}
//         disabled={isReadOnly}
//         options={[
//           { value: "Sale", display_value: "Sale" },
//           { value: "Purchase", display_value: "Purchase" },
//           { value: "Letting", display_value: "Letting" },
//         ]}
//         isReport={isReport}
//       />
//       {formData.transactionType === "Sale" && (
//         <>
//           <div className="Transaction_price">
//             <div style={{ width: '30%' }}>
//               <SelectCurrency
//                 label={`Currency`}
//                 isReport={isReport}
//                 name={"currency"}
//                 value={formData.currency}
//                 disabled={isReadOnly}
//                 onChange={handleChange} />

//             </div>
//             <div style={{ width: '70%' }}>
//               <Input
//                 label="Sale Price"
//                 name="salePrice"
//                 type="text"
//                 value={formData.salePrice}
//                 onChange={handleChange} // let them type normally
//                 onBlur={(e) => {
//                   const valueWithoutCommas = e.target.value.replace(/,/g, "");
//                   handleChange({ target: { name: "salePrice", value: valueWithoutCommas } });
//                 }}
//                 // onChange={handleChange}
//                 disabled={isReadOnly}
//                 required
//                 isReport={isReport}
//                 tooltip={tooltips.salePrice}
//               />

//             </div>



//           </div>


//           <RadioGroup
//             label="Sale Type"
//             name="saleType"
//             value={formData.saleType}
//             onChange={handleChange}
//             disabled={isReadOnly}
//             isReport={isReport}
//             options={[
//               { value: "Freehold", display_value: "Freehold" },
//               { value: "Leasehold", display_value: "Leasehold" },
//             ]}
//           />
//         </>
//       )}

//       {formData.transactionType === "Purchase" && (
//         <>
//           <div className="Transaction_price">
//             <div style={{ width: '30%' }}>
//             <SelectCurrency
//                 label={`Currency`}
//                 isReport={isReport}
//                 name={"currency"}
//                 value={formData.currency}
//                 disabled={isReadOnly}
//                 onChange={handleChange} />

//             </div>
//             <div style={{ width: '70%' }}>
//               <Input
//                 label="Purchase Price"
//                 name="purchasePrice"
//                 type="text"
//                 isReport={isReport}
//                 value={formData.purchasePrice}
//                 onChange={handleChange}
//                 disabled={isReadOnly}
//                 required
//               />

//             </div>



//           </div>

//           <RadioGroup
//             name="saleType"
//             value={formData.saleType}
//             onChange={handleChange}
//             disabled={isReadOnly}
//             isReport={isReport}
//             label="Sale Type"
//             options={[
//               { value: "Freehold", display_value: "Freehold" },
//               { value: "Leasehold", display_value: "Leasehold" },
//             ]}
//           />
//         </>
//       )}

//       {formData.transactionType === "Letting" && (
//         <>
//           <div className="Transaction_price">
//             <div style={{ width: '70%' }}>
//               <Input
//                 label="Term"
//                 name="term"
//                 type="number"
//                 isReport={isReport}
//                 value={formData.term}
//                 onChange={handleChange}
//                 disabled={isReadOnly}
//                 required
//               />

//             </div>
//             <div style={{ width: '30%' }}>
//               <Select
//                 label="Month/Years"
//                 name="duration"
//                 isReport={isReport}
//                 value={formData.duration}
//                 onChange={handleChange}
//                 disabled={isReadOnly}
//                 options={[
//                   { value: "Months", display_value: "Months" },
//                   { value: "Year", display_value: "Year" },
//                 ]}
//               />

//             </div>




//           </div>


//           <div className="Transaction_price">
//             <div style={{ width: '30%' }}>
//             <SelectCurrency
//                 label={`Currency`}
//                 isReport={isReport}
//                 name={"currency"}
//                 value={formData.currency}
//                 disabled={isReadOnly}
//                 onChange={handleChange} />

//             </div>
//             <div style={{ width: '70%' }}>
//               <Input
//                 label="Rate Per Annum"
//                 name="ratePerAnnum"
//                 type="number"
//                 step="any"
//                 value={formData.ratePerAnnum}
//                 onChange={handleChange}
//                 disabled={isReadOnly}
//                 required
//                 isReport={isReport}
//               />

//             </div>



//           </div>


//         </>
//       )}

//       <Input
//         label="Internal Transaction Reference:"
//         name="transactionReference"
//         type="text"
//         isReport={isReport}
//         value={formData.transactionReference}
//         onChange={handleChange}
//         disabled={isReadOnly}
//       />

//       <Input
//         label="Transaction Description:"
//         name="description"
//         type="text"
//         isReport={isReport}
//         value={formData.description}
//         onChange={handleChange}
//         disabled={isReadOnly}
//       />

//       <Input
//         label="Heads of Term Date::"
//         name="headsOfTermDate"
//         type="Date"
//         isReport={isReport}
//         value={formData.headsOfTermDate}
//         onChange={handleChange}
//         disabled={isReadOnly}
//       />

//       <Input
//         label="Anticipated Completion Date:"
//         name="anticipatedCompletionDate"
//         type="Date"
//         isReport={isReport}
//         value={formData.anticipatedCompletionDate}
//         onChange={handleChange}
//         disabled={isReadOnly}
//       />
//     </form>
//   );
// };



import React from "react";
import { Select } from "../../ui/Select";
import { Input } from "../../ui/Input";
import { RadioGroup } from "../../ui/RadioGroup";
import { SelectCurrency } from "../../selectors/currency/selectCurrency";
// import { useTooltips } from "../../hooks/toolTips"; // Adjust path as needed
import { useTooltips } from "../../../hooks/toolTips";

export const TransactionForm = ({
  formData,
  existingTransaction,
  handleChange,
  isReadOnly,
  handleUpdate,
  handleTransactionChange,
  isSelectorReadOnly,
  isReport,
}) => {
  const tooltips = useTooltips();
  // Show a warning whenever the user's typed Term value is a decimal — they
  // are NOT blocked from typing, but the form save / validate flow rejects
  // the value (see useTransaction.handleSubmit / validatePage).
  const termIsDecimal =
    typeof formData.term === "string" && /[.,]/.test(formData.term);
  const termError = termIsDecimal
    ? "Decimal value is not allowed. Please enter a whole number before saving."
    : "";

  const getTooltipForField = (label, name) => {
    if (!tooltips || tooltips.length === 0) return "";
    const match = tooltips.find(
      (t) =>
        t.Label?.toLowerCase() === label?.toLowerCase() ||
        t.Name?.toLowerCase() === name?.toLowerCase()
    );
    return match?.Tooltip && match.Tooltip !== "123" ? match.Tooltip : "";
  };

  return (
    <form onSubmit={handleUpdate}>
       <div className="top-section">
         <h2>Transaction Details</h2>
      {!isReport && (
        <Select
          isReport={isReport}
          label="Quick Fill Existing Transaction:"
          name="transactionId"
          value={formData.transactionId}
          disabled={isReadOnly || isSelectorReadOnly}
          options={
            existingTransaction && existingTransaction.length > 0
              ? existingTransaction
                  .filter((value) => value != null)
                  .map((value) => parseInt(value))
                  .sort((a, b) => b - a)
                  .map((value) => ({
                    value,
                    display_value: value,
                  }))
              : [{ value: "", display_value: "No Transactions available" }]
          }
          onChange={handleTransactionChange}
          // tooltip={getTooltipForField("Quick Fill Existing Transaction", "transactionId")}
        />
      )}

<Input
  label="Transaction ID"
  name="transactionId"
  value={formData.transactionId || ""}
  placeholder={"Auto Generated"}
  onChange={handleChange}
  disabled={true}
  isReport={isReport}
/>

  

      <Input
        label="Transaction Status"
        type="text"
        value={formData.status}
        disabled={true}
        isReport={isReport}
        tooltip={getTooltipForField("Transaction Status", "status")}
      />
</div>
 <div className="bottom-section">
  <h3>New Transaction</h3>
      <RadioGroup
        label="Transaction Type"
        name="transactionType"
        required={true}
        value={formData.transactionType}
        onChange={handleChange}
        disabled={isReadOnly}
        options={[
          { value: "Sale", display_value: "Sale" },
          { value: "Purchase", display_value: "Purchase" },
          { value: "Letting", display_value: "Letting" },
        ]}
        isReport={isReport}
        tooltip={getTooltipForField("Transaction Type", "transactionType")}
      />

      {formData.transactionType === "Sale" && (
        <>
          <div className="Transaction_price">
            <div style={{ width: "30%" }}>
              <SelectCurrency
                label="Currency"
                isReport={isReport}
                name="currency"
                value={formData.currency}
                disabled={isReadOnly}
                onChange={handleChange}
                tooltip={getTooltipForField("Currency", "currency")}
              />
            </div>
            <div style={{ width: "70%" }}>
              <Input
                label="Sale Price"
                name="salePrice"
                type="text"
                value={formData.salePrice}
                onChange={handleChange}
                onBlur={(e) => {
                  const valueWithoutCommas = e.target.value.replace(/,/g, "");
                  handleChange({ target: { name: "salePrice", value: valueWithoutCommas } });
                }}
                disabled={isReadOnly}
                required
                isReport={isReport}
                tooltip={getTooltipForField("Sale Price", "salePrice")}
              />
            </div>
          </div>

          <RadioGroup
            label="Sale Type"
            name="saleType"
            value={formData.saleType}
            onChange={handleChange}
            disabled={isReadOnly}
            isReport={isReport}
            options={[
              { value: "Freehold", display_value: "Freehold" },
              { value: "Leasehold", display_value: "Leasehold" },
            ]}
            tooltip={getTooltipForField("Sale Type", "saleType")}
          />
        </>
      )}

      {formData.transactionType === "Purchase" && (
        <>
          <div className="Transaction_price">
            <div style={{ width: "30%" }}>
              <SelectCurrency
                label="Currency"
                isReport={isReport}
                name="currency"
                value={formData.currency}
                disabled={isReadOnly}
                onChange={handleChange}
                tooltip={getTooltipForField("Currency", "currency")}
              />
            </div>
            <div style={{ width: "70%" }}>
              <Input
                label="Purchase Price"
                name="purchasePrice"
                type="text"
                isReport={isReport}
                value={formData.purchasePrice}
                onChange={handleChange}
                disabled={isReadOnly}
                required
                tooltip={getTooltipForField("Purchase Price", "purchasePrice")}
              />
            </div>
          </div>

          <RadioGroup
            name="saleType"
            value={formData.saleType}
            onChange={handleChange}
            disabled={isReadOnly}
            isReport={isReport}
            label="Sale Type"
            options={[
              { value: "Freehold", display_value: "Freehold" },
              { value: "Leasehold", display_value: "Leasehold" },
            ]}
            tooltip={getTooltipForField("Sale Type", "saleType")}
          />
        </>
      )}

      {formData.transactionType === "Letting" && (
        <>
          <div className="Transaction_price">
            <div style={{ width: "70%", position: "relative" }}>
              <Input
                label="Term"
                name="term"
                type="number"
                min="0"
                isReport={isReport}
                value={formData.term}
                onChange={handleChange}
                disabled={isReadOnly}
                required
                tooltip={getTooltipForField("Term", "term")}
              />
              {termError && (
                <div
                  key={termError + Date.now()}
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    color: "#d9534f",
                    backgroundColor: "#fdecea",
                    border: "1px solid #f5c2c0",
                    borderRadius: "4px",
                    fontSize: "13px",
                    fontWeight: 500,
                    marginTop: "4px",
                    padding: "6px 10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    animation: "termErrorShake 0.35s",
                    zIndex: 2,
                  }}
                  role="alert"
                >
                  <span style={{ fontSize: "16px" }}>⚠️</span>
                  {termError}
                </div>
              )}
              <style>{`
                @keyframes termErrorShake {
                  0%, 100% { transform: translateX(0); }
                  20% { transform: translateX(-4px); }
                  40% { transform: translateX(4px); }
                  60% { transform: translateX(-3px); }
                  80% { transform: translateX(3px); }
                }
              `}</style>
            </div>
            <div style={{ width: "30%" }}>
              <Select
                label="Month/Years"
                name="duration"
                isReport={isReport}
                value={formData.duration}
                onChange={handleChange}
                disabled={isReadOnly}
                options={[
                  { value: "Months", display_value: "Months" },
                  { value: "Year", display_value: "Years" },
                ]}
                tooltip={getTooltipForField("Month/Years", "duration")}
              />
            </div>
          </div>

          <div className="Transaction_price">
            <div style={{ width: "30%" }}>
              <SelectCurrency
                label="Currency"
                isReport={isReport}
                name="currency"
                value={formData.currency}
                disabled={isReadOnly}
                onChange={handleChange}
                tooltip={getTooltipForField("Currency", "currency")}
              />
            </div>
            <div style={{ width: "70%" }}>
              <Input
                label="Highest Ascertainable Rent Per Annum"
                name="ratePerAnnum"
                type="number"
                step="any"
                value={formData.ratePerAnnum}
                onChange={handleChange}
                disabled={isReadOnly}
                required
                isReport={isReport}
                tooltip={getTooltipForField("Rate Per Annum", "ratePerAnnum")}
              />
            </div>
          </div>
        </>
      )}

      <Input
        label="Internal Transaction Reference:"
        name="transactionReference"
        type="text"
        isReport={isReport}
        value={formData.transactionReference}
        onChange={handleChange}
        disabled={isReadOnly}
        tooltip={getTooltipForField("Internal Transaction Reference", "transactionReference")}
      />

      <Input
        label="Transaction Description:"
        name="description"
        type="text"
        isReport={isReport}
        value={formData.description}
        onChange={handleChange}
        disabled={isReadOnly}
        tooltip={getTooltipForField("Transaction Description", "description")}
      />

      <Input
        label="Heads of Term Date:"
        name="headsOfTermDate"
        type="Date"
        isReport={isReport}
        value={formData.headsOfTermDate}
        onChange={handleChange}
        disabled={isReadOnly}
        tooltip={getTooltipForField("Heads of Term Date", "headsOfTermDate")}
      />

      <Input
        label="Anticipated Completion Date:"
        name="anticipatedCompletionDate"
        type="Date"
        isReport={isReport}
        value={formData.anticipatedCompletionDate}
        onChange={handleChange}
        disabled={isReadOnly}
        tooltip={getTooltipForField("Anticipated Completion Date", "anticipatedCompletionDate")}
      />
      </div>
    </form>
  );
};
